import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const MIN_OWNER_FEES = 10

export function calcNights(startDate: Date, endDate: Date) {
  return Math.ceil(dayjs(endDate).diff(startDate, 'day', true))
}

export function calcDays(startDate: Date, endDate: Date) {
  return calcNights(startDate, endDate) + 1
}
